import {cDisplay} from '../creator/cDisplay'
import { infoBubble } from '../creator/cDisplayObjects/infoBubble';
import { cGame } from '../creator/cGame';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cText } from "../creator/cGameObjects/cText";
import {cScene} from '../creator/cScene'
import { net } from '../creator/utils/net';


export class backpack2Display extends cDisplay {

  private MAX_PAGES: number = 57;
  private curIndex: number = 1;

  init(){
    super.init()
    console.log('INIT BACKPACK 2', (this.scene as cScene).customeOptions);

    var cS:cScene = this.scene as cScene

    (this.scene as cScene).ev.addListener('action',(type,action)=>{

      switch (action.command){
        case 'add_score':
          break;


        case 'show_stickers':

          // var countCompleted = ['2::badge_bunte','2::badge_dss','2::badge_pas','2::badge_qpd','2::badge_tuba','2::badge_ulf'].reduce( (p:any,val)=>{
          //   var ff = cGame.current.state.get(val,'-')
          //   var res = (ff === 'show' ? 1 : 0)
          //   return p + res
          // },0);

          // if (cGame.current.state.get('2::badge_completed','-') === '-'){
          //   if (countCompleted === 6){
          //     cGame.current.state.set('2::badge_completed',1)
          //     cS.triggerSceneEvent('badge_completed')
          //   }
          // }          
          break;
      }

    })

    setTimeout( ()=>{
    },1)

  }

  buildScene(){    
    super.buildScene();      

    var cS:cScene = this.scene as cScene
    var gameslist = ["ruleform","representative","stage","ballot","party","slogan","tuba","utilities","setup","electioncheck"];
    var score = cGame.current.state.get('2::scoring',[]) 

    var scoreText = []
    var summ = 0
    gameslist.forEach( (nm)=>{
      scoreText.push( typeof score[nm] != 'undefined' ? score[nm] : '')
      summ += score[nm] ? Number(score[nm]) : 0 
      console.log(nm,score[nm])
    })

    scoreText.push(summ)
    
    var txt:cText = this.getByName('pointcard_scores');
    if (txt){
      txt.textdata = scoreText.join('\n');
    }
    console.log(scoreText.join(  '\n'))


    

  }

}
